module.exports = __webpack_public_path__ + "media/notification.af249954.ogg";